import IconArrowRight from "../../images/icon_arrow_right.svg";
import {
  StepContent,
  StepDescription,
  StepNumber,
  StepsBar,
} from "./StepsStyles";

function Steps(props) {
  const { stepsInfo, updateScreen, currentScreenName, title, makeDisable } =
    props;

  return (
    <StepsBar>
      <h1>{title}</h1>
      <div className="step-tabs">
        {stepsInfo.map((step, index) => {
          const isCurrent = step.screenName === currentScreenName;
          return (
            <StepContent key={index} className="step-name">
              <StepNumber
                activated={isCurrent}
                onClick={() => {
                  if (!makeDisable) {
                    updateScreen(step.screenName);
                  }
                }}
              >
                {index + 1}
              </StepNumber>
              <div
                onClick={() => {
                  if (!makeDisable) {
                    updateScreen(step.screenName);
                  }
                }}
                onKeyDown={() => {}}
                role="button"
              >
                <StepDescription isCurrent={isCurrent}>
                  {step.description}
                </StepDescription>
              </div>

              <div className="arrowIcon">
                {index === stepsInfo.length - 1 ? null : (
                  <img src={IconArrowRight} alt="arrowRight"></img>
                )}
              </div>
            </StepContent>
          );
        })}
      </div>
    </StepsBar>
  );
}

export default Steps;
